<div class="scaffold-table-holder">
    <table [nbTreeGrid]="item.data" style="width:100%;">
        <ng-container [nbColumnDef]="col" *ngFor="let col of columns">
            <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef>{{col}}</th>
            <td nbTreeGridCell *nbTreeGridCellDef="let element"> {{element[col]}} </td>
        </ng-container>
        <tr nbTreeGridHeaderRow  *nbTreeGridHeaderRowDef="columns"></tr>
        <tr nbTreeGridRow *nbTreeGridRowDef="let row; columns: columns;"></tr>
        
    </table>
</div>
